export default __webpack_public_path__ + "static/media/mobile-photo-6.b97f7ea1.jpg";